// extracted by mini-css-extract-plugin
module.exports = {"title":"_2NyjeEdqqqPCedSUmv_Mjy","colorLump":"_2i_K5IVz6uAQR7t2Yi0ejA"};